var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEconomy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.783,
    height: 16.141,
    viewBox: "0 0 10.783 13.141",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "seat",
    transform: "translate(-37.333)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2781",
    "data-name": "Group 2781",
    transform: "translate(37.333 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2780",
    "data-name": "Group 2780",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_40775",
    "data-name": "Path 40775",
    d: "M103.635,2.3a1.349,1.349,0,1,0-1.907,0A1.35,1.35,0,0,0,103.635,2.3Z",
    transform: "translate(-99.312 0)",
    fill: "CurrentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40776",
    "data-name": "Path 40776",
    d: "M106.679,111.954h-2.315v-2.48a6.44,6.44,0,0,0,3.706,1.456v-1.456a4.552,4.552,0,0,1-3.147-1.375l-.943-1.045a1.519,1.519,0,0,0-.462-.34,1.478,1.478,0,0,0-.65-.155h-.017a1.522,1.522,0,0,0-1.52,1.52v3.875a2.023,2.023,0,0,0,2.022,2.022h3.413l2.359,2.359.967-.967Z",
    transform: "translate(-99.31 -103.193)",
    fill: "CurrentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40777",
    "data-name": "Path 40777",
    d: "M38.681,112.732v-6.065H37.333v6.065a3.371,3.371,0,0,0,3.37,3.37h4.043v-1.348H40.7A2.023,2.023,0,0,1,38.681,112.732Z",
    transform: "translate(-37.333 -103.297)",
    fill: "CurrentColor"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEconomy);
export default __webpack_public_path__ + "static/media/economy.e749d6f1.svg";
export { ForwardRef as ReactComponent };